import { httpRequest } from '../../../../app/common/util/api-common.util';

class ErrataAPI {
  static cancelamentoErrata(laudo, justificativa) {
    return httpRequest(`laudos/${laudo}/etapas/errata/cancelamento`, 'PATCH', {
      justificativa: justificativa,
    }).then((json) => json.data);
  }
}

export default ErrataAPI;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/erratas/erratas.api.js